import React, { useContext, useState } from 'react'
import Swal from 'sweetalert2';
import { deleteCardById, getCards, postCards, consultCardByNumber } from '../api/cards';
import { AuthContext } from '../context/AuthContext';

export const useCards = () => {
    const { setLoading,checkToken } = useContext(AuthContext);
    const [cards, setCards] = useState([]);

    const getCard = async () => {
        checkToken()
        setLoading(true)

        try {
            const { data } = await getCards();
            setLoading(false)

            //console.log(data)   
            //setLoading(false)
            setCards([...data.data]);
        } catch (e) {
            setLoading(false)
            // console.log(e);
            setCards([]);
        }
    }

    const createCard = async (data) => {
        checkToken()
        try {
            setLoading(true)
            await postCards(data);
            setLoading(false)
            return true;
        } catch (e) {
            setLoading(false)
            console.log(e)
            // if (e.code == "ERR_NETWORK") {
            //     Swal.fire({
            //       title: 'Advertencia',
            //       text: "Su solicitud no puede ser procesada",
            //       icon: 'warning',
            //       showCancelButton: false,
            //       confirmButtonColor: '#fd6e0d',
            //       iconColor: "#fd6e0d",
            //       confirmButtonText: 'Entendido'
            //     })
            //   } else {
            //     if (e.response.data.code == "CARD_NOT_FOUND") {
            //     } else {
            //       Swal.fire({
            //         title: 'Advertencia',
            //         text: "Su solicitud no puede ser procesada",
            //         icon: 'warning',
            //         iconColor: "#fd6e0d",
            //         showCancelButton: false,
            //         confirmButtonColor: '#fd6e0d',
            //         confirmButtonText: 'Entendido'
            //       })
            //     }
            //   }
            return false;
        }
    }

    const deleteCard = async (id) => {
        checkToken()
        try {
            setLoading(true)
            await deleteCardById(id);
            setLoading(false)
            return true;
        } catch (e) {
            setLoading(false)
            //console.log(e.response)
            return false;
        }
    }

    const consultCard = async (number) => {
        checkToken()
        try {
            setLoading(true)
            const data = await consultCardByNumber(number);
            //console.log(data.data)
            setLoading(false)
            return data.data;
        } catch (e) {
            setLoading(false)
            if (e.code == "ERR_NETWORK") {
                Swal.fire({
                    showCloseButton: true,
                  title: 'Advertencia',
                  text: "Su solicitud no puede ser procesada",
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#fd6e0d',
                  iconColor: "#fd6e0d",
                  confirmButtonText: 'Entendido'
                })
              } else {
                // Swal.fire({
                //     title: 'Advertencia',
                //     text: "Su solicitud no puede ser procesada",
                //     icon: 'warning',
                //     iconColor: "#fd6e0d",
                //     showCancelButton: false,
                //     confirmButtonColor: '#fd6e0d',
                //     confirmButtonText: 'Entendido'
                //   })
                // if (e.response.data.code == "USER_ALREADY_EXISTS") {
                //   Swal.fire({
                //     title: 'Advertencia',
                //     text: "El teléfono ya se encuentra registrado",
                //     icon: 'warning',
                //     iconColor: "#fd6e0d",
                //     showCancelButton: false,
                //     confirmButtonColor: '#fd6e0d',
                //     confirmButtonText: 'Entendido'
                //   })
                // } else {
                //   Swal.fire({
                //     title: 'Advertencia',
                //     text: "Su solicitud no puede ser procesada",
                //     icon: 'warning',
                //     iconColor: "#fd6e0d",
                //     showCancelButton: false,
                //     confirmButtonColor: '#fd6e0d',
                //     confirmButtonText: 'Entendido'
                //   })
                // }
              }
            return false;
        }
    }


    return {
        cards,
        getCard,
        createCard,
        deleteCard,
        consultCard
    }
}
